import React, { useLayoutEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { SIDEBAR_ANIMATION_DURATION } from 'containers/Home/constants';
import './index.css';

const AnimationWrapper = ({
  children,
  animation = 'fade-in',
  className = '',
  style = {},
  delay = 0,
  duration = SIDEBAR_ANIMATION_DURATION,
  ...props
}) => {
  const [animationClass, setAnimationClass] = useState('');
  const elementRef = useRef(null);

  useLayoutEffect(() => {
    // Set the CSS custom property on this specific element
    if (elementRef.current) {
      elementRef.current.style.setProperty('--animation-duration', `${duration}ms`);
    }

    if (delay > 0) {
      const timer = setTimeout(() => {
        setAnimationClass(animation);
      }, delay);
      return () => clearTimeout(timer);
    } else {
      setAnimationClass(animation);
    }
  }, [animation, delay, duration]);

  return (
    <div
      ref={elementRef}
      className={`${animationClass} ${className}`.trim()}
      style={style}
      {...props}
    >
      {children}
    </div>
  );
};

AnimationWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  animation: PropTypes.oneOf([
    'fade-in',
    'fade-in-slow',
    'fade-in-fast',
    'slide-in-right',
    'slide-in-left',
    'slide-in-up',
    'slide-in-down',
    'scale-in'
  ]),
  className: PropTypes.string,
  style: PropTypes.object,
  delay: PropTypes.number,
  duration: PropTypes.number,
};

export default AnimationWrapper; 